const route = (token = ':token') => `/${token}`;

export default route;
